import type { ReactNode } from 'react';

// 메인(/)과 서비스소개(/service/*)의 "At a Glance" 섹션이 함께 쓰는 서비스 목록.
// 앱 구성(2026-09-25~): 성도 앱 · 앱관리 앱 · 교적부 앱 · 재정 앱 · 주일학교 앱.
// 4열 격자(모바일 2열)가 딱 떨어지도록 항목 수를 4의 배수로 유지할 것.
export type ServiceApp = '성도 앱' | '앱관리 앱' | '교적부 앱' | '재정 앱' | '주일학교 앱';

export type GlanceItem = { title: string; desc: string; app: ServiceApp; icon: ReactNode };

export const GLANCE_HEADLINE = { services: '열여섯 개의 서비스', apps: '다섯 개의' };

export const GLANCE: GlanceItem[] = [
  {
    title: '모바일주보',
    desc: '매주 자동 발행, 성도 알림',
    app: '성도 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 4h7v16H4zM13 4h7v16h-7zM4 8h7M13 8h7" />
      </svg>
    ),
  },
  {
    title: '교회소식',
    desc: '공지 · 행사 · 감사 게시판',
    app: '성도 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 11l14-6v14L3 13zM3 11v2M17 8v8" />
      </svg>
    ),
  },
  {
    title: '성경읽기',
    desc: '매일성경 · 통독 · 묵상',
    app: '성도 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 4h11a3 3 0 013 3v13H8a3 3 0 01-3-3zM5 17a3 3 0 013-3h11" />
      </svg>
    ),
  },
  {
    title: '설교영상',
    desc: '실시간 방송 · 아카이브',
    app: '성도 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M10 8l6 4-6 4z" />
      </svg>
    ),
  },
  {
    title: '갤러리',
    desc: '앨범별 사진 아카이브',
    app: '성도 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="1" />
        <circle cx="9" cy="10" r="1.5" />
        <path d="M3 17l5-5 4 4 3-3 6 6" />
      </svg>
    ),
  },
  {
    title: '콘텐츠 관리',
    desc: '주보 · 소식 · 설교 · 갤러리 편집',
    app: '앱관리 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: '알림 발송',
    desc: '성도 전체 푸시 알림',
    app: '앱관리 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 16V11a6 6 0 0112 0v5l2 2H4zM10 20a2 2 0 004 0" />
      </svg>
    ),
  },
  {
    title: '담당자 권한',
    desc: '가입 승인 · 재정 권한 부여',
    app: '앱관리 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="8" r="3.5" />
        <path d="M5 20c0-3.3 3.1-6 7-6s7 2.7 7 6" />
      </svg>
    ),
  },
  {
    title: '교적관리',
    desc: '성도 프로필 · 직분 관리',
    app: '교적부 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="9" cy="8" r="3" />
        <path d="M3 20c0-3 3-5 6-5s6 2 6 5M15 6h6M15 10h6M15 14h4" />
      </svg>
    ),
  },
  {
    title: '출석부',
    desc: '현장 · 온라인 · 결석 체크',
    app: '교적부 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="4" y="5" width="16" height="15" rx="1" />
        <path d="M4 9h16M8 3v4M16 3v4M8 14l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: '심방관리',
    desc: '심방 일정 · 상담 기록',
    app: '교적부 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 11l8-7 8 7v9H4zM10 20v-5h4v5" />
      </svg>
    ),
  },
  {
    title: '재정관리',
    desc: '수입 · 지출 · 월 예산',
    app: '재정 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <ellipse cx="12" cy="6" rx="7" ry="2.5" />
        <path d="M5 6v6c0 1.4 3.1 2.5 7 2.5s7-1.1 7-2.5V6M5 12v6c0 1.4 3.1 2.5 7 2.5s7-1.1 7-2.5v-6" />
      </svg>
    ),
  },
  {
    title: '출석 체크',
    desc: '저장하면 학부모에게 도착 알림',
    app: '주일학교 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M8 12l3 3 5-6" />
      </svg>
    ),
  },
  {
    title: '알림장',
    desc: '확인 요청 · 미확인 자동 재발송',
    app: '주일학교 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 5h16v11H9l-5 4zM8 9h8M8 12h5" />
      </svg>
    ),
  },
  {
    title: '학생 교적',
    desc: '신앙 여정 · 교사 메모',
    app: '주일학교 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 4h11a3 3 0 013 3v13H8a3 3 0 01-3-3zM9 9h6M9 13h4" />
      </svg>
    ),
  },
  {
    title: '학부모 연결',
    desc: '자녀 정보로 가입 · 반 교사 승인',
    app: '주일학교 앱',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="8" cy="8" r="3" />
        <circle cx="17" cy="10" r="2.2" />
        <path d="M2.5 20c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5M14 20c0-2.3 1.4-4.2 3-4.2s3 1.9 3 4.2" />
      </svg>
    ),
  },
];

/** 메인·서비스소개 공용 At a Glance 그리드 (스타일은 각 페이지 scss의 .glance-*) */
export function GlanceGrid() {
  return (
    <div className="glance-grid reveal">
      {GLANCE.map((item) => (
        <div className="glance-item" key={item.title}>
          <div className="glance-icon">{item.icon}</div>
          <span className="glance-app">{item.app}</span>
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </div>
      ))}
    </div>
  );
}
